import { useState, useCallback } from "react";

export const useIndependentTabLoading = (initialTabs = {}) => {
  const [tabStates, setTabStates] = useState(initialTabs);

  const setTabLoading = useCallback((tabName, loading) => {
    setTabStates(prev => ({
      ...prev,
      [tabName]: {
        ...prev[tabName],
        loading,
        error: loading ? null : prev[tabName]?.error,
      }
    }));
  }, []);

  const setTabError = useCallback((tabName, error) => {
    setTabStates(prev => ({
      ...prev,
      [tabName]: {
        ...prev[tabName],
        loading: false,
        error,
      }
    }));
  }, []);

  const setTabData = useCallback((tabName, data) => {
    setTabStates(prev => ({
      ...prev,
      [tabName]: {
        ...prev[tabName],
        loading: false,
        error: null,
        data,
      }
    }));
  }, []);

  const retryTab = useCallback((tabName, retryFunction) => {
    setTabLoading(tabName, true);
    if (retryFunction) {
      retryFunction();
    }
  }, [setTabLoading]);

  const getTabState = useCallback((tabName) => {
    return tabStates[tabName] || { loading: false, error: null, data: null };
  }, [tabStates]);

  const isAnyTabLoading = useCallback(() => {
    return Object.values(tabStates).some(state => state.loading);
  }, [tabStates]);

  const hasAnyTabError = useCallback(() => {
    return Object.values(tabStates).some(state => state.error);
  }, [tabStates]);

  return {
    tabStates,
    setTabLoading,
    setTabError,
    setTabData,
    retryTab,
    getTabState,
    isAnyTabLoading,
    hasAnyTabError,
  };
};
